import React, { FC } from 'react';
import { createGlobalStyle } from 'styled-components';
import DownArrowIcon from './icon/DownArrowIcon';
import useAutocomplete from '@mui/material/useAutocomplete';
import StarIcon from './startIcon.png';
import Container from 'saur_ui_library/src/Atoms/Container/Container';

type AutocompleteProps = {
  Listoption: any;
  getOptionValue: any;
  onChangeValue: any;
  id: any;
  getOptionSelected?: any;
};

const Autocomplete: FC<AutocompleteProps> = (props) => {
  const {
    getRootProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
  } = useAutocomplete({
    id: 'autocomplete-flow',
    options: props.Listoption,
    getOptionLabel: props.getOptionValue,
    onChange: props.onChangeValue,
    // getOptionSelected: props.getOptionSelected,
  });

  return (
    <Container className='sds-reset-style'>
      <Container className='autocomplete'>
        <Styles />
        <div className='autocomplete-input' {...getRootProps()}>
          <input
            id={props.id}
            className='input'
            {...getInputProps()}
            placeholder='Toutes'
          />
          <Container className='dropdown-icon-container'>
            <DownArrowIcon
              className='autocomplete-downIcon'
              width='4.4%'
            ></DownArrowIcon>
          </Container>
        </div>
        <Container className='list-content'>
          {groupedOptions.length > 0 ? (
            <ul className='listbox' {...getListboxProps()}>
              {groupedOptions.map((option: any, index: any) => (
                <li
                  className='elementList'
                  {...getOptionProps({ option, index })}
                >
                  {option.name}
                  {option.id && (
                    <img
                      src={StarIcon}
                      style={{ width: '20px', height: '20px' }}
                      alt='star'
                    />
                  )}
                </li>
              ))}
            </ul>
          ) : null}
        </Container>
      </Container>
    </Container>
  );
};

export const Styles = createGlobalStyle`
.sds-reset-style{
  .autocomplete{
      margin-left: 0;
      position: relative;
      .input{
        margin-top: 0;
        margin-left: 0;
      height: 55px;
      background-color: #edf2fa;
      border-color: #edf2fa;
      position: relative;
      padding:  0px 15px;
      font-family: "Montserrat";
      font-size: 14px;
      font-style: Italic;
    };
    .list-content{
      background-color: red
    }
    .listbox{
      position: absolute;
      margin-left:0;
      width: 100%;
      transform: translateY(2%);
      max-height: auto;
      margin: 0;
      padding: 0;
      z-index: 20;
      font-family: "Montserrat";
      list-style: none;
      background-color: white;
      box-shadow: 0 14px 14px 3px rgba(16, 26, 49, 0.1);
      overflow-y: scroll;
      li[data-focus="true"] {
        background-color: #cce8f6;
        color: "black";
        cursor: "pointer";
      };
      li:active {
        background-color: #cce8f6;
        color: "black";
      };
      li:hover{
          background-color:#cce8f6
      }
    };
    .elementList{
    padding-left:20px;
    padding-bottom:10px;
    padding-top:10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    };  
  }
  svg.autocomplete-downIcon{   
    transform: translateY(-50%);
    position: absolute;
    right: 20px;
    width: 15px;
    height: 9px;
    top: 29px;
    pointer-events: none
  }
}
 
  `;

export default Autocomplete;
